import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DelegatesService } from 'src/app/services/delegates.service';

@Component({
  selector: 'app-transfer',
  templateUrl: './transfer.component.html',
})
export class TransferComponent implements OnInit {
  candidates: any[] = [];
  candidateId: string = '';
  comment: string = '';

  @Input() item: any;
  @Input() info: any;

  constructor(
    private readonly modalService: NgbModal,
    private readonly activeModal: NgbActiveModal,
    private readonly delegateService: DelegatesService
  ) {}

  ngOnInit(): void {
    this.delegateService.getCandidates().subscribe((data: any) => {
      this.candidates = data;
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  confirmTransfer() {
    this.activeModal.close({
      info: this.info,
      comment: this.comment,
      candidate: this.candidateId,
    });
  }
}
